import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function useGalleryAnchor(id: string) {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#' + id) return;
    let active = true;
    const align = () => {
      if (active) document.getElementById(id)?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash, id]);
}
